import React from "react";
import { FormattedMessage } from "react-intl";
import { Button, InlineLoading } from "@wfp/ui";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSync } from "@fortawesome/free-solid-svg-icons";

import "./_syncFooter.scss";
import { SyncProgress } from "data-handler/ducks/stores";

type SyncFooterProps = {
  onBackgroundSync: () => void;
  onClose: () => void;
  isBackgroundSyncInProgress: boolean;
  isDisabled: boolean;
  asyncSyncStatus: string;
  progress?: SyncProgress | null;
};

const SyncFooter: React.ComponentType<SyncFooterProps> = ({
  onBackgroundSync,
  onClose,
  isBackgroundSyncInProgress,
  isDisabled,
  asyncSyncStatus,
  progress,
}) => {
  const getBackgroundButtonText = () => {
    if (asyncSyncStatus === "submitting") {
      return (
        <FormattedMessage
          id="SyncFooter.submitting"
          defaultMessage="Submitting..."
        />
      );
    }
    if (asyncSyncStatus === "polling" && progress?.is_stale) {
      return (
        <span className="sync-footer__reconnecting">
          <FontAwesomeIcon icon={faSync} spin />
          <FormattedMessage
            id="SyncFooter.reconnecting"
            defaultMessage="Reconnecting..."
          />
        </span>
      );
    }
    return (
      <FormattedMessage
        id="SyncFooter.syncInBackground"
        defaultMessage="Sync in background"
      />
    );
  };

  return (
    <div className="sync-footer">
      <Button kind="secondary" onClick={onClose} className="sync-footer__close">
        <FormattedMessage id="SyncFooter.close" defaultMessage="Close" />
      </Button>

      <div className="sync-footer__actions">
        <Button
          kind="primary"
          onClick={onBackgroundSync}
          disabled={isDisabled || isBackgroundSyncInProgress}
          className="sync-footer__background"
        >
          <span className="sync-footer__button-content">
            {isBackgroundSyncInProgress && <InlineLoading />}
            {getBackgroundButtonText()}
          </span>
        </Button>
      </div>
    </div>
  );
};

export default SyncFooter;
